export default "__VITE_ASSET__D2MkE5dO__"